import { render, staticRenderFns } from "./TipsPromo.vue?vue&type=template&id=13c25e37&"
import script from "./TipsPromo.vue?vue&type=script&lang=js&"
export * from "./TipsPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports